import React, { SVGProps } from 'react';

const Email = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 16 15"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon--box"
      {...props}
    >
      <path
        d="M17.5 0C20.2614 0 22.5 2.23858 22.5 5V15C22.5 17.7614 20.2614 20 17.5 20H5.5C2.73858 20 0.5 17.7614 0.5 15V5C0.5 2.23858 2.73858 0 5.5 0H17.5ZM20.5 5C20.5 3.34315 19.1569 2 17.5 2L5.5 2C3.84315 2 2.5 3.34315 2.5 5L2.5 6.4199L11.5 11.3778L20.5 6.4199V5ZM20.5 8.70329L16.491 10.9117L20.5 14.3205V8.70329ZM14.6174 11.9439L11.5 13.6611L8.38261 11.9439L2.94272 16.5694C3.47058 17.4277 4.41845 18 5.5 18H17.5C18.5816 18 19.5294 17.4277 20.0573 16.5693L14.6174 11.9439ZM6.50899 10.9117L2.5 8.70329L2.5 14.3205L6.50899 10.9117Z"
        fill="#141928"
      />
    </svg>
  );
};

Email.displayName = 'Email';

export default Email;
